import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetPlatformClientRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetPlatformClientResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getPlatformClient = (request: GetPlatformClientRequest, options?: CashRequestOptions) =>
  post<GetPlatformClientRequest, GetPlatformClientResponse>('/2.0/cash/get-platform-client', request, {
    ...options,
    rejectOnError: true,
  })
